
function whenConsentResolved(fn) {
  window.didomiOnReady = window.didomiOnReady || [];
  window.didomiOnReady.push(fn);
}

export function pushEvent(eventName, ecommerce, extra) {
  if (typeof window === 'undefined') return;
 
  whenConsentResolved(function () {
    window.dataLayer = window.dataLayer || [];
 
    if (ecommerce) {
      window.dataLayer.push({ ecommerce: null });
    }
 
    window.dataLayer.push(
      Object.assign({ event: eventName }, ecommerce ? { ecommerce: ecommerce } : {}, extra || {})
    );
  });
}

function applyOrderDiscount(rows, orderDiscount) {
  if (!rows) return;

  const subtotal = rows.reduce((s, i) => s + (i.totalCampaignPriceExcludingVat ?? i.totalPriceExcludingVat), 0);
  if (!subtotal) return rows;
  orderDiscount = Math.abs(orderDiscount);
  let allocated = 0;

  return rows.map((row, idx) => {
    const lineGross = row.totalCampaignPriceExcludingVat ?? row.totalPriceExcludingVat;
    const isLast = idx === rows.length - 1;

    const lineDiscount = isLast
      ? orderDiscount - allocated
      : Math.round((orderDiscount * lineGross) / subtotal * 100) / 100;
    allocated += lineDiscount;
    if (lineDiscount === 0) {
      return {
        ...row,
        totalPriceIncludingOrderDiscount: lineGross,
        rowOrderDiscount: 0,
      };
    }
    return {
      ...row,
      totalPriceIncludingOrderDiscount: Math.round((lineGross - lineDiscount) * 100) / 100,
      rowOrderDiscount: Math.round(lineDiscount * 100) / 100,
    };
  });
}

export function pushAddToCart(articleNumber, cart) {
  if (!articleNumber || !cart) return;

  const allocated = applyOrderDiscount(cart.orderRows, cart.orderDiscountTotalExcludingVat);
  const row = allocated.find((r) => r.articleNumber === articleNumber);

  if (!row) return;
  if (row.quantity === 0) return; 

  const unitPrice = row.totalPriceIncludingOrderDiscount / row.quantity;
  const payload = {
    value: unitPrice,
    currency: cart.currencyCode,
    items: [{
      item_id: row.articleNumber,
      item_name: row.name,
      price: unitPrice,
      quantity: 1
    }]};

    pushEvent('add_to_cart', payload);
}